<script setup>
import { onMounted, ref, computed, inject, watch } from 'vue';
import axios from 'axios';

const props = defineProps({
    previousQuestion: Object,
    question: String,
    answer: String,
    type: {
        type: String,
        default: 'completion',
        required: false,
    },
    activeChannel: Object,
    enabled: Boolean,
});

const question = ref(props.question);
const enabled = ref(props.enabled);

const progressBarClass = computed(() => {
    if (props.previousQuestion === null) {
        return 'bg-gray-500';
    }

    if (props.previousQuestion === 0) {
        return 'bg-red-500 w-0';
    }

    if (props.previousQuestion === 25) {
        return 'bg-orange-500 w-1/4';
    }

    if (props.previousQuestion === 50) {
        return 'bg-orange-500 w-1/2';
    }

    if (props.previousQuestion === 75) {
        return 'bg-yellow-500 w-3/4';
    }

    if (props.previousQuestion === 100) {
        return 'bg-green-500 w-full';
    }
});

</script>

<template>
    <div>
        <div
            v-if="enabled"
            class="mb-3"
        >
            <div class="text-xs text-gray-400">{{ question }}</div>
            <div>{{ answer }}</div>
            <div
                v-if="previousQuestion !== null && typeof(previousQuestion) !== 'undefined'"
            >
                <div
                    v-if="type === 'completion'"
                    class="flex h-4 w-full"
                >
                    <div
                        class="relative flex justify-end rounded-full pr-1 text-white min-w-7 text-xxs"
                        :class="progressBarClass"
                    >
                        <div >
                            {{ previousQuestion }}%
                        </div>
                    </div>
                </div>
                <div
                    v-else-if="type === 'boolean'"
                >
                    <span v-if="previousQuestion === true">
                        {{ _mft('shared:confirm.positive') }}
                    </span>
                    <span v-if="previousQuestion === false">
                        {{ _mft('shared:confirm.negative') }}
                    </span>
                </div>
                <div v-else>
                    {{ previousQuestion }}
                </div>
            </div>
            <div
                v-else
                class="italic text-xs"
            >
                No answer
            </div>
        </div>
    </div>
</template>
